import { defineComponent as _defineComponent } from 'vue'
import IconProject from '@/components/svg/project.svg?inline';
import IconReceivedOffers from '@/components/svg/receivedoffers.svg?inline';
import IconMadeOffers from '@/components/svg/madeoffers.svg?inline';
import IconWatchlist from '@/components/svg/watchlist.svg?inline';
import IconCreatedlist from '@/components/svg/createdlist.svg?inline';
import IconContractNotes from '@/components/svg/contract-notes.svg?inline';
import IconSignedContract from '@/components/svg/signed-contract.svg?inline';
import IconContractBaseData from '@/components/svg/profile-public-projects.svg?inline';
import IconContractNotes2 from '@/components/svg/notes.svg?inline';
import IconContractArrow from '@/components/svg/contract-arrow.svg?inline';
import IconContractUrgent from '@/components/svg/contract-urgent.svg?inline';
import IconContractIncoming from '@/components/svg/contract-incoming.svg?inline';
import IconContractOutgoing from '@/components/svg/contract-outgoing.svg?inline';
import IconInvoice from '@/components/svg/invoice.svg?inline';
import iconStandardContract from '@/components/svg/standardContract.svg?inline';

import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsSectionHeader',
  props: {
  title: {
    type: String,
    default: ''
  },
  icon: {
    type: String as PropType<keyof typeof icons>,
    required: true
  },
  paddingBottom: {
    type: String,
    default: '36px'
  }
},
  setup(__props) {

const icons = {
  overview: IconProject,
  offers: IconReceivedOffers,
  watchlist: IconWatchlist,
  createdlist: IconCreatedlist,
  madeOffers: IconMadeOffers,
  contract: IconContractNotes,
  contractnotes: IconContractNotes2,
  signedcontract: IconSignedContract,
  contractbasedata: IconContractBaseData,
  contractarrow: IconContractArrow,
  contracturgent: IconContractUrgent,
  contractincoming: IconContractIncoming,
  contractoutgoing: IconContractOutgoing,
  invoice: IconInvoice,
  standardContract: iconStandardContract,
};



return { __sfc: true,icons }
}

})